<p-dialog 
  [(visible)]="visible" 
  [modal]="true" 
  [closable]="false" 
  [style]="{width: '37.5rem'}"
  styleClass="bulk-upload-dialog">
  
  <ng-template pTemplate="header">
    <div class="dialog-header flex items-center justify-between">
      <div class="flex items-center gap-3">
        <button 
          type="button" 
          pButton 
          icon="pi pi-arrow-left" 
          class="back-button-icon"
          [text]="true"
          [rounded]="true"
          (click)="onBack()">
        </button>
        <span class="dialog-title">{{ title }}</span>
      </div>
    </div>
  </ng-template>
  
  <div class="p-dialog-content">
    <form [formGroup]="uploadForm" class="bulk-upload-form">
      <!-- Upload Section -->
      <div class="upload-section">
          <div class="upload-area" 
             [class.has-file]="selectedFile"
             (click)="!selectedFile && openFileDialog()"
             (dragover)="$event.preventDefault(); $event.stopPropagation()"
             (dragleave)="$event.preventDefault(); $event.stopPropagation()"
             (drop)="onFileDrop($event); $event.preventDefault(); $event.stopPropagation()">
          
          <input 
            #fileInput
            type="file" 
            accept=".xlsx,.xls,.csv"
            (change)="onFileSelect($event)"
            style="display: none;">
          
          <div *ngIf="!selectedFile" class="upload-placeholder">
            <i class="pi pi-cloud-upload upload-icon"></i>
            <p class="upload-text">Drag and drop your file here</p>
            <p class="upload-subtext">or</p>
            <div class="button-group">
              <button 
                type="button" 
                pButton 
                icon="pi pi-folder-open" 
                label="Browse Files" 
                severity="secondary"
                class="browse-files-btn"
                (click)="$event.stopPropagation(); openFileDialog()">
              </button>
              <button 
                type="button" 
                pButton 
                icon="pi pi-download" 
                label="Download CSV" 
                severity="secondary"
                class="download-template-btn button-spacing"
                (click)="$event.stopPropagation(); downloadTemplate()">
              </button>
            </div>
            <p class="upload-hint">Supported formats: .xlsx, .xls, .csv</p>
          </div>
          
          <div *ngIf="selectedFile" class="file-selected">
            <div class="file-info">
              <i class="pi pi-file file-icon"></i>
              <div class="file-details">
                <span class="file-name">{{ fileName }}</span>
                <button 
                  type="button" 
                  pButton 
                  icon="pi pi-times" 
                  [text]="true"
                  [rounded]="true"
                  class="remove-file-btn"
                  (click)="removeFile()">
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- Validation Errors Section -->
    <div *ngIf="showValidationErrors && validationErrors.length > 0" class="validation-errors-section">
      <div class="errors-header">
        <div class="errors-title">
          <i class="pi pi-exclamation-triangle error-icon"></i>
          <span class="error-title-text">{{ errorMessage }}</span>
        </div>
        <div class="errors-summary">
          <span class="error-count">Errors: {{ errorCount }}</span>
          <span *ngIf="successCount > 0" class="success-count">Success: {{ successCount }}</span>
        </div>
      </div>
      <div class="errors-table-container">
        <p-table 
          [value]="validationErrors" 
          [paginator]="true"
          [rows]="10"
          styleClass="validation-errors-table"
          [scrollable]="true"
          scrollHeight="300px">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 80px">Row</th>
              <th>Column</th>
              <th>Value</th>
              <th>Error</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-error>
            <tr>
              <td>{{ error.row }}</td>
              <td>{{ error.column }}</td>
              <td class="error-value">{{ error.value || '-' }}</td>
              <td class="error-message">{{ error.error }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="errors-footer">
        <button 
          type="button" 
          pButton 
          label="Close" 
          severity="secondary"
          (click)="closeValidationErrors()">
        </button>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button 
        type="button" 
        pButton 
        label="Cancel" 
        severity="secondary"
        (click)="onClose()">
      </button>
      <button 
        type="button" 
        pButton 
        label="Upload" 
        [disabled]="!selectedFile || isUploading"
        [loading]="isUploading"
        (click)="onUpload()">
      </button>
    </div>
  </ng-template>
</p-dialog>

